import cx from 'classnames';
import React from 'react';
import trendingModels from './trendingModels';
import { useInputContext } from '../../../context/InputContext';
import DefaultSuggestionClicked from '../../../contracts/DefaultSuggestionClicked';
import {
  modalStyles,
  SectionTitle,
  SuggestionLinkText,
  SuggestionLinkWrapper,
  SuggestionSectionContainer
} from '../DefaultSuggestions.styles';

type OwnProps = {
  handleDefaultSuggestionClicked: DefaultSuggestionClicked;
  inModal?: boolean;
};

export default function DefaultTrending({
  handleDefaultSuggestionClicked,
  inModal
}: OwnProps) {
  const { inputValue } = useInputContext();

  return (
    <SuggestionSectionContainer>
      <SectionTitle className={inModal ? 'pl-16' : ''}>
        Trending models
      </SectionTitle>
      <div className={cx('flex gap-8', inModal ? modalStyles : 'flex-wrap')}>
        {trendingModels.map(model => (
          <SuggestionLinkWrapper
            data-analytics-id="Default Suggestions"
            data-analytics-attributes={JSON.stringify({
              category: 'Trending Models',
              label: model.text,
              textEntered: inputValue
            })}
            data-qa="Default Search Trending"
            defaultSuggestion={model}
            handleDefaultSuggestionClicked={handleDefaultSuggestionClicked}
            key={model.text}
          >
            <SuggestionLinkText>{model.text}</SuggestionLinkText>
          </SuggestionLinkWrapper>
        ))}
      </div>
    </SuggestionSectionContainer>
  );
}
